import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "6"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#999",
      "fill-rule": "nonzero"
    }, [
      _createElementVNode("path", { d: "M6.997 3.209c-2.514 0-5.025-.767-6.813-2.296A.517.517 0 1 1 .865.136C4.02 2.86 9.988 2.86 13.129.136a.517.517 0 0 1 .681.777c-1.788 1.53-4.299 2.296-6.813 2.296" }),
      _createElementVNode("path", { d: "M5.13 5.464a.4.4 0 0 1-.092 0 .51.51 0 0 1-.426-.617l.341-2.01a.519.519 0 0 1 1.022.178l-.34 2.01a.51.51 0 0 1-.505.439m7.658-1.022a.5.5 0 0 1-.36-.153l-1.68-1.704a.511.511 0 1 1 .725-.715l1.68 1.703c.199.2.199.523 0 .722a.53.53 0 0 1-.365.147m-11.582 0a.53.53 0 0 1-.341-.147c-.2-.199-.2-.522 0-.722l1.68-1.703a.511.511 0 1 1 .705.715L1.57 4.29a.5.5 0 0 1-.364.153m7.682 1.022a.51.51 0 0 1-.501-.422l-.34-2.01a.511.511 0 1 1 .994-.195l.34 2.01a.51.51 0 0 1-.412.593.4.4 0 0 1-.081.024" })
    ], -1)
  ])))
}
export default { render: render }